document.addEventListener("DOMContentLoaded", () => {
  /*
   * Paid embroidery add-on variant IDs.
   * Front embroidery is included in the base hat price.
   */
  const EMBROIDERY_ADDON_VARIANTS = {
    left: 47348543619156,
    right: 47348543651924,
    rear: 47348543684692
  };

  function show(el) {
    if (el) {
      el.hidden = false;
      el.style.display = "block";
    }
  }

  function hide(el) {
    if (el) {
      el.hidden = true;
      el.style.display = "none";
    }
  }

  function getLocationName(card) {
    return (
      card
        .querySelector(".embroidery-header__text strong")
        ?.textContent
        ?.replace(" Embroidery", "")
        ?.trim() || "Location"
    );
  }

  function getLocationKey(card) {
    const location = getLocationName(card).toLowerCase();

    if (location.includes("left")) {
      return "left";
    }

    if (location.includes("right")) {
      return "right";
    }

    if (location.includes("rear")) {
      return "rear";
    }

    if (location.includes("front")) {
      return "front";
    }

    return null;
  }

  function createHatBundleId() {
    return `hat-${Date.now()}-${Math.random()
      .toString(36)
      .slice(2, 10)}`;
  }

  function getProgressSection() {
    const list = document.getElementById(
      "hat-builder-summary-list"
    );

    if (!list) return null;

    return (
      list.closest(
        ".hat-builder-summary, " +
        ".hat-builder__summary, " +
        ".customization-progress, " +
        ".hat-builder-progress, " +
        ".hat-builder__section, " +
        ".hat-builder-section, " +
        "section"
      ) || list.parentElement
    );
  }

  function hasSelectedLocations() {
    return Array.from(
      document.querySelectorAll(
        ".embroidery-card .location-checkbox"
      )
    ).some(checkbox => checkbox.checked);
  }

  function getSelectedPaidLocationCount() {
    let paidLocationCount = 0;

    document
      .querySelectorAll(".embroidery-card")
      .forEach(card => {
        const checkbox = card.querySelector(
          ".location-checkbox"
        );

        if (!checkbox?.checked) return;

        const locationKey = getLocationKey(card);

        if (
          locationKey === "left" ||
          locationKey === "right" ||
          locationKey === "rear"
        ) {
          paidLocationCount += 1;
        }
      });

    return paidLocationCount;
  }

  function notifyQuantityDiscountComponent() {
    document.dispatchEvent(
      new CustomEvent("hatBuilder:addonsChanged", {
        detail: {
          paidLocationCount:
            getSelectedPaidLocationCount()
        }
      })
    );
  }

  function updateProgressVisibility() {
    const progressSection = getProgressSection();

    if (!progressSection) return;

    if (hasSelectedLocations()) {
      show(progressSection);
    } else {
      hide(progressSection);
    }
  }

  function clearCardError(card) {
    if (!card) return;

    card.classList.remove("has-error");
    card.querySelector(".embroidery-error")?.remove();
  }

  function showCardError(card, message) {
    if (!card) return;

    clearCardError(card);
    card.classList.add("has-error");

    const error = document.createElement("div");

    error.className = "embroidery-error";
    error.textContent = message;

    card
      .querySelector(".embroidery-content")
      ?.appendChild(error);
  }

  function clearCartError() {
    document
      .querySelector(".hat-builder-cart-error")
      ?.remove();
  }

  function showCartError(productForm, message) {
    clearCartError();

    const error = document.createElement("div");

    error.className =
      "hat-builder-cart-error form__message";

    error.setAttribute("role", "alert");
    error.textContent = message;

    productForm.insertAdjacentElement(
      "beforebegin",
      error
    );

    error.scrollIntoView({
      behavior: "smooth",
      block: "center"
    });
  }

  function setLogoFileName(card, fileName) {
    const logoFileField = card.querySelector(
      ".location-logo-file"
    );

    if (logoFileField) {
      logoFileField.value = fileName
        ? `${fileName}`
        : "";
    }
  }

  function clearLogoFields(card) {
    const upload = card.querySelector(
      ".location-upload"
    );

    const url = card.querySelector(
      ".location-url"
    );

    const preview = card.querySelector(
      ".upload-preview"
    );

    const status = card.querySelector(
      ".upload-status"
    );

    if (upload) {
      upload.value = "";
    }

    if (url) {
      url.value = "";
    }

    setLogoFileName(card, "");

    if (preview) {
      preview.innerHTML = "";
    }

    if (status) {
      status.textContent = "No file selected.";
    }
  }

  function clearTextFields(card) {
    const textInput = card.querySelector(
      ".location-text"
    );

    const colorSelect = card.querySelector(
      "select"
    );

    if (textInput) {
      textInput.value = "";
    }

    if (colorSelect) {
      colorSelect.value = "";
    }
  }

  function resetEmbroideryCard(card) {
    const checkbox = card.querySelector(
      ".location-checkbox"
    );

    const content = card.querySelector(
      ".embroidery-content"
    );

    const logoSection = card.querySelector(
      ".logo-upload-option"
    );

    const textSection = card.querySelector(
      ".text-option"
    );

    clearCardError(card);

    if (checkbox) {
      checkbox.checked = false;
    }

    card.classList.remove(
      "active",
      "is-complete"
    );

    card
      .querySelectorAll('input[type="radio"]')
      .forEach(radio => {
        radio.checked = false;
      });

    clearLogoFields(card);
    clearTextFields(card);

    hide(content);
    hide(logoSection);
    hide(textSection);
  }

  function updateCardStatus(card) {
    const checkbox = card.querySelector(
      ".location-checkbox"
    );

    const selected = card.querySelector(
      'input[type="radio"]:checked'
    );

    const logoUrl = card
      .querySelector(".location-url")
      ?.value.trim();

    const fileSelected =
      card.querySelector(".location-upload")
        ?.files.length > 0;

    const text = card
      .querySelector(".location-text")
      ?.value.trim();

    const color = card
      .querySelector("select")
      ?.value.trim();

    card.classList.remove("is-complete");

    if (!checkbox?.checked || !selected) {
      return;
    }

    if (
      selected.value === "Logo" &&
      (logoUrl || fileSelected)
    ) {
      card.classList.add("is-complete");
    }

    if (
      selected.value === "Text" &&
      text &&
      color
    ) {
      card.classList.add("is-complete");
    }
  }

  function updateSummary() {
    const list = document.getElementById(
      "hat-builder-summary-list"
    );

    if (!list) {
      updateProgressVisibility();
      return;
    }

    list.innerHTML = "";

    document
      .querySelectorAll(".embroidery-card")
      .forEach(card => {
        const checkbox = card.querySelector(
          ".location-checkbox"
        );

        if (!checkbox?.checked) return;

        const location = getLocationName(card);

        const selected = card.querySelector(
          'input[type="radio"]:checked'
        );

        const logoUrl = card
          .querySelector(".location-url")
          ?.value.trim();

        const fileSelected =
          card.querySelector(".location-upload")
            ?.files.length > 0;

        const text = card
          .querySelector(".location-text")
          ?.value.trim();

        const color = card
          .querySelector("select")
          ?.value.trim();

        let summary =
          `${location}: Select customization type`;

        if (selected?.value === "Logo") {
          summary = logoUrl
            ? `${location}: Logo/image uploaded`
            : fileSelected
              ? `${location}: Logo/image selected`
              : `${location}: Waiting for logo/image`;
        }

        if (selected?.value === "Text") {
          if (!text) {
            summary =
              `${location}: Waiting for text`;
          } else if (!color) {
            summary =
              `${location}: Waiting for thread color`;
          } else {
            summary =
              `${location}: Text "${text}" in ${color}`;
          }
        }

        const li = document.createElement("li");

        li.textContent = summary;
        list.appendChild(li);
      });

    updateProgressVisibility();
  }

  function initializeCustomizationToggle(card) {
    const radios = card.querySelectorAll(
      'input[type="radio"]'
    );

    const logoSection = card.querySelector(
      ".logo-upload-option"
    );

    const textSection = card.querySelector(
      ".text-option"
    );

    hide(logoSection);
    hide(textSection);

    radios.forEach(radio => {
      radio.addEventListener("change", () => {
        clearCardError(card);
        clearCartError();

        if (radio.value === "Logo") {
          show(logoSection);
          hide(textSection);
          clearTextFields(card);
        }

        if (radio.value === "Text") {
          hide(logoSection);
          show(textSection);
          clearLogoFields(card);
        }

        updateCardStatus(card);
        updateSummary();
      });
    });
  }

  function initializeEmbroideryBuilder() {
    document
      .querySelectorAll(".embroidery-card")
      .forEach(card => {
        const checkbox = card.querySelector(".location-checkbox");
        const content = card.querySelector(".embroidery-content");

        if (!checkbox || !content) return;

        clearCardError(card);

        if (checkbox.checked) {
          card.classList.add("active");
          show(content);
        } else {
          card.classList.remove("active", "is-complete");
          hide(content);
        }

        initializeCustomizationToggle(card);

        checkbox.addEventListener("change", () => {
          clearCardError(card);
          clearCartError();

          if (checkbox.checked) {
            card.classList.add("active");
            show(content);
          } else {
            resetEmbroideryCard(card);
          }

          updateCardStatus(card);
          updateSummary();
          notifyQuantityDiscountComponent();
        });
      });

    updateSummary();
    updateProgressVisibility();
    notifyQuantityDiscountComponent();
  }

  function initializeCloudinaryUploads() {
    document
      .querySelectorAll(".location-upload")
      .forEach(input => {
        const card = input.closest(
          ".embroidery-card"
        );

        if (!card) return;

        const status = card.querySelector(
          ".upload-status"
        );

        const urlField = card.querySelector(
          ".location-url"
        );

        let preview = card.querySelector(
          ".upload-preview"
        );

        if (!preview) {
          preview = document.createElement("div");
          preview.className = "upload-preview";

          input.insertAdjacentElement(
            "afterend",
            preview
          );
        }

        input.addEventListener("change", () => {
          clearCardError(card);
          clearCartError();

          if (urlField) {
            urlField.value = "";
          }

          setLogoFileName(card, "");

          if (!input.files.length) {
            if (status) {
              status.textContent =
                "No file selected.";
            }

            preview.innerHTML = "";

            updateCardStatus(card);
            updateSummary();

            return;
          }

          const file = input.files[0];

          const localPreviewUrl =
            URL.createObjectURL(file);

          setLogoFileName(card, file.name);

          if (status) {
            status.textContent =
              `Selected: ${file.name}. ` +
              "This will upload when you add to cart.";
          }

          preview.innerHTML = `
            <img
              src="${localPreviewUrl}"
              alt="Selected embroidery preview"
            >
          `;

          updateCardStatus(card);
          updateSummary();
        });
      });
  }

  async function uploadPendingLogoFiles() {
    const cards = document.querySelectorAll(
      ".embroidery-card"
    );

    for (const card of cards) {
      const checkbox = card.querySelector(
        ".location-checkbox"
      );

      const selectedType = card.querySelector(
        'input[type="radio"]:checked'
      );

      if (
        !checkbox?.checked ||
        selectedType?.value !== "Logo"
      ) {
        continue;
      }

      const input = card.querySelector(
        ".location-upload"
      );

      const urlField = card.querySelector(
        ".location-url"
      );

      const status = card.querySelector(
        ".upload-status"
      );

      const location = getLocationName(card);

      if (!input || !urlField) continue;

      if (urlField.value.trim()) {
        continue;
      }

      if (!input.files.length) {
        continue;
      }

      const file = input.files[0];

      if (status) {
        status.textContent =
          `Uploading ${file.name}...`;
      }

      const formData = new FormData();

      formData.append("file", file);

      formData.append(
        "upload_preset",
        "gotime_hat_uploads"
      );

      try {
        const response = await fetch(
          "https://api.cloudinary.com/v1_1/" +
          "vxrlenfc/auto/upload",
          {
            method: "POST",
            body: formData
          }
        );

        const data = await response.json();

        if (!response.ok || !data.secure_url) {
          console.error(
            "Cloudinary error:",
            data
          );

          if (status) {
            status.textContent =
              "Upload failed. Please try again.";
          }

          showCardError(
            card,
            `${location} artwork upload failed. ` +
            "Please try again."
          );

          return false;
        }

        urlField.value = data.secure_url;
        setLogoFileName(card, file.name);

        if (status) {
          status.textContent =
            `✅ ${file.name} uploaded successfully.`;
        }

        updateCardStatus(card);
        updateSummary();
      } catch (error) {
        console.error(
          "Cloudinary upload failed:",
          error
        );

        if (status) {
          status.textContent =
            "Upload failed. Please try again.";
        }

        showCardError(
          card,
          `${location} artwork upload failed. ` +
          "Please try again."
        );

        return false;
      }
    }

    return true;
  }

  function initializeFieldTracking() {
    const trackedFields =
      document.querySelectorAll(
        ".location-text, .embroidery-card select"
      );

    trackedFields.forEach(field => {
      const updateFieldStatus = () => {
        const card = field.closest(
          ".embroidery-card"
        );

        if (!card) return;

        clearCardError(card);
        clearCartError();
        updateCardStatus(card);
        updateSummary();
      };

      field.addEventListener(
        "input",
        updateFieldStatus
      );

      field.addEventListener(
        "change",
        updateFieldStatus
      );
    });
  }

  function validateEmbroideryBuilder() {
    let firstInvalid = null;

    document
      .querySelectorAll(".embroidery-card")
      .forEach(card => {
        clearCardError(card);

        const checkbox = card.querySelector(
          ".location-checkbox"
        );

        if (!checkbox?.checked) return;

        const location = getLocationName(card);

        const selected = card.querySelector(
          'input[type="radio"]:checked'
        );

        if (!selected) {
          showCardError(
            card,
            "Please choose Logo/Image or " +
            `Embroidered Text for ${location}.`
          );

          firstInvalid ||= card;
          return;
        }

        if (selected.value === "Logo") {
          const logoUrl = card
            .querySelector(".location-url")
            ?.value.trim();

          const fileSelected =
            card.querySelector(".location-upload")
              ?.files.length > 0;

          if (!logoUrl && !fileSelected) {
            showCardError(
              card,
              `Please upload artwork for ${location}.`
            );

            firstInvalid ||= card;
            return;
          }
        }

        if (selected.value === "Text") {
          const text = card
            .querySelector(".location-text")
            ?.value.trim();

          const color = card
            .querySelector("select")
            ?.value.trim();

          if (!text) {
            showCardError(
              card,
              "Please enter embroidered text " +
              `for ${location}.`
            );

            firstInvalid ||= card;
            return;
          }

          if (!color) {
            showCardError(
              card,
              "Please choose an embroidery color " +
              `for ${location}.`
            );

            firstInvalid ||= card;
          }
        }
      });

    if (firstInvalid) {
      firstInvalid.scrollIntoView({
        behavior: "smooth",
        block: "center"
      });

      return false;
    }

    return true;
  }

  function getAddonVariantId(card) {
    const locationKey = getLocationKey(card);

    if (
      !locationKey ||
      !EMBROIDERY_ADDON_VARIANTS[locationKey]
    ) {
      return null;
    }

    return EMBROIDERY_ADDON_VARIANTS[locationKey];
  }

  function getMainProductProperties(
    productForm,
    bundleId
  ) {
    const formData = new FormData(productForm);
    const properties = {};

    for (const [name, value] of formData.entries()) {
      const propertyMatch = name.match(
        /^properties\[(.+)\]$/
      );

      if (!propertyMatch) continue;

      if (value instanceof File) continue;

      const propertyName = propertyMatch[1];
      const propertyValue = String(value).trim();

      if (!propertyValue) continue;

      properties[propertyName] = propertyValue;
    }

    /*
     * Private Shopify line-item properties.
     * These link the visible hat to its hidden add-ons.
     */
    properties["_Hat Bundle ID"] = bundleId;
    properties["_Configured Hat"] = "Yes";

    return properties;
  }

  function getAddonProperties(
    card,
    bundleId
  ) {
    const location = getLocationName(card);

    return {
      "_Embroidery Add-on": "Yes",
      "_Embroidery Location": location,
      "_Hide From Cart": "Yes",
      "_Hat Bundle ID": bundleId
    };
  }

  function getSelectedAddonItems(
    quantity,
    bundleId
  ) {
    const addonItems = [];

    document
      .querySelectorAll(".embroidery-card")
      .forEach(card => {
        const checkbox = card.querySelector(
          ".location-checkbox"
        );

        if (!checkbox?.checked) return;

        const variantId =
          getAddonVariantId(card);

        /*
         * Front embroidery is included and does not
         * create a paid add-on line.
         */
        if (!variantId) return;

        addonItems.push({
          id: variantId,
          quantity,
          properties: getAddonProperties(
            card,
            bundleId
          )
        });
      });

    return addonItems;
  }

  function getProductVariantId(productForm) {
    const variantInput = productForm.querySelector(
      'input[name="id"], select[name="id"]'
    );

    const variantId = parseInt(
      variantInput?.value,
      10
    );

    return Number.isInteger(variantId)
      ? variantId
      : null;
  }

  function getProductQuantity(productForm) {
    const quantityInput = productForm.querySelector(
      'input[name="quantity"]'
    );

    return Math.max(
      1,
      parseInt(quantityInput?.value, 10) || 1
    );
  }

  async function addHatAndAddonsToCart(
    productForm
  ) {
    const mainVariantId =
      getProductVariantId(productForm);

    const quantity =
      getProductQuantity(productForm);

    if (!mainVariantId) {
      throw new Error(
        "Please select a valid hat option."
      );
    }

    /*
     * Every configured hat receives a unique bundle ID.
     * This also prevents Shopify from merging separate
     * configurations into the same cart line.
     */
    const bundleId = createHatBundleId();

    const mainItem = {
      id: mainVariantId,
      quantity,
      properties:
        getMainProductProperties(
          productForm,
          bundleId
        )
    };

    const sellingPlanInput =
      productForm.querySelector(
        '[name="selling_plan"]'
      );

    if (sellingPlanInput?.value) {
      mainItem.selling_plan = parseInt(
        sellingPlanInput.value,
        10
      );
    }

    const addonItems =
      getSelectedAddonItems(
        quantity,
        bundleId
      );

    const cartItems = [
      mainItem,
      ...addonItems
    ];

    const rootRoute =
      window.Shopify?.routes?.root || "/";

    const response = await fetch(
      `${rootRoute}cart/add.js`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({
          items: cartItems
        })
      }
    );

    let responseData = {};

    try {
      responseData = await response.json();
    } catch (error) {
      console.error(
        "Could not parse cart response:",
        error
      );
    }

    if (!response.ok) {
      throw new Error(
        responseData.description ||
        responseData.message ||
        "The customized hat could not be added."
      );
    }

    return responseData;
  }

  function setAddButtonLoading(
    addButton,
    isLoading
  ) {
    addButton.disabled = isLoading;

    addButton.classList.toggle(
      "loading",
      isLoading
    );

    if (isLoading) {
      addButton.setAttribute(
        "aria-disabled",
        "true"
      );
    } else {
      addButton.removeAttribute(
        "aria-disabled"
      );
    }
  }

  function initializeFormValidation() {
    const hatBuilder = document.querySelector(
      ".hat-builder"
    );

    if (!hatBuilder) return;

    const productForm = document.querySelector(
      'product-form form[action="/cart/add"], ' +
      'form[data-type="add-to-cart-form"]'
    );

    if (!productForm) return;

    const addButton = productForm.querySelector(
      'button[name="add"], ' +
      ".product-form__submit"
    );

    if (!addButton) return;

    let isSubmitting = false;

    async function prepareAndSubmit(event) {
      /*
       * Prevent Dawn from separately submitting the
       * main product. The Ajax request adds the hat and
       * all paid embroidery add-ons together.
       */
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      if (isSubmitting) {
        return false;
      }

      clearCartError();

      if (!validateEmbroideryBuilder()) {
        return false;
      }

      isSubmitting = true;
      setAddButtonLoading(addButton, true);

      try {
        const uploadedSuccessfully =
          await uploadPendingLogoFiles();

        if (!uploadedSuccessfully) {
          throw new Error(
            "One or more artwork files could " +
            "not be uploaded. Please try again."
          );
        }

        if (!validateEmbroideryBuilder()) {
          throw new Error(
            "Please complete the selected " +
            "embroidery options."
          );
        }

        await addHatAndAddonsToCart(
          productForm
        );

        const rootRoute =
          window.Shopify?.routes?.root || "/";

        window.location.href =
          `${rootRoute}cart`;

        return true;
      } catch (error) {
        console.error(
          "Hat builder cart submission failed:",
          error
        );

        showCartError(
          productForm,
          error.message ||
          "The customized hat could not be " +
          "added. Please try again."
        );

        isSubmitting = false;

        setAddButtonLoading(
          addButton,
          false
        );

        return false;
      }
    }

    productForm.addEventListener(
      "submit",
      prepareAndSubmit,
      true
    );
  }

  initializeEmbroideryBuilder();
  initializeCloudinaryUploads();
  initializeFieldTracking();
  initializeFormValidation();
  updateSummary();

  notifyQuantityDiscountComponent();
});